import { render, staticRenderFns } from "./AddPhone.vue?vue&type=template&id=489ced7c&scoped=true&"
import script from "./AddPhone.vue?vue&type=script&lang=js&"
export * from "./AddPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ced7c",
  null
  
)

export default component.exports